import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Sidebar from "react-sidebar";
import { Container } from "reactstrap";
import { Helmet } from "react-helmet";

import Header from "./Header";
import Menu from "./Menu";
import Breadcrumbs from "../Breadcrumbs";

import colors from "../../colors";

import { sidebarToggle } from "../../app/actions";

const mql = window.matchMedia(`(min-width: 800px)`);

class SiteTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mql: mql,
      sidebarDocked: true
    };
  }
  componentDidMount() {
    mql.addListener(this.mediaQueryChanged);
    this.setState({ mql: mql, sidebarDocked: mql.matches });
  }

  componentWillUnmount() {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen = open => {
    const { sidebarToggle } = this.props;
    sidebarToggle();
  };

  mediaQueryChanged = () => {
    this.setState({ sidebarDocked: this.state.mql.matches });
  };

  render() {
    const { children, title, sidebarOpen } = this.props;
    return (
      <div>
        <Helmet>
          <title>{title} | OpiekujSię.pl</title>
        </Helmet>
        <Header />
        <Sidebar
          sidebar={<Menu />}
          open={sidebarOpen}
          docked={this.state.sidebarDocked}
          onSetOpen={this.onSetSidebarOpen}
          touch={false}
          transitions={false}
          shadow={false}
          styles={{
            root: {
              top: 55
            },
            sidebar: {
              width: 260,
              backgroundColor: colors.sidebarBg
            },
            overlay: {
              top: 55,
              left: 260
            }
          }}
        >
          <Title>{title}</Title>
          <Container fluid>
            <Breadcrumbs />
            <Panel>{children}</Panel>
          </Container>
        </Sidebar>
      </div>
    );
  }
}

const Title = styled.div.attrs({ className: "text-dark" })`
  display: flex;
  align-items: center;
  font-size: 18px;
  height: 55px;
  background-color: white;
  border-bottom: 1px solid #c2cfd6;
  padding-left: 20px;
  user-select: none;
`;

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  margin-bottom: 25px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.04);
  border-width: 0;
  border-radius: 3px;
  margin: 20px 10px 0px;
`;

SiteTemplate = connect(state => ({ sidebarOpen: state.app.sidebarOpen }), {
  sidebarToggle
})(SiteTemplate);
export default SiteTemplate;



// WEBPACK FOOTER //
// ./src/components/Site/SiteTemplate.js